import cn from "classnames";

import { ImageMessage } from "../../aiConversations.types";
import { AssistantAvatar } from "../AssistantAvatar";
import { BubbleMeta } from "../BubbleMeta";

import styles from "./ImageBubble.module.scss";

interface Props {
  message: ImageMessage;
  incomingAvatar?: string;
  incomingName?: string;
  onCorrect?: () => void;
}

const IncomingAvatar = ({ name, url }: { name: string; url?: string }) => {
  if (url) {
    return <img className={styles.incomingAvatarImg} src={url} alt={name} />;
  }
  const initials = name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return <div className={styles.incomingAvatar}>{initials}</div>;
};

const ImageBubble = ({
  message,
  incomingAvatar,
  incomingName = "?",
  onCorrect
}: Props) => {
  const isOutgoing = message.direction === "outgoing";

  return (
    <div
      className={cn(styles.row, {
        [styles.rowOutgoing]: isOutgoing,
        [styles.rowIncoming]: !isOutgoing
      })}
    >
      {!isOutgoing && <IncomingAvatar name={incomingName} url={incomingAvatar} />}

      <div
        className={cn(styles.bubbleWrapper, {
          [styles.bubbleWrapperOutgoing]: isOutgoing,
          [styles.bubbleWrapperIncoming]: !isOutgoing
        })}
      >
        <a
          className={styles.imageLink}
          href={message.mediaUrl}
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.image} src={message.mediaUrl} alt="" />
        </a>
        {message.text ? <div className={styles.caption}>{message.text}</div> : null}
        <BubbleMeta message={message} onCorrect={onCorrect} />
      </div>

      {isOutgoing && <AssistantAvatar letter="A" size={24} />}
    </div>
  );
};

export default ImageBubble;
